import React from 'react'

import { Box, Flex, Header, Text } from '@driftt/dds'

import RefreshActivity from 'components/RefreshActivity'
import { driftErrorStateBuilder } from 'components/States'
import useDashboardInsights from 'hooks/useDashboardInsights'
import { useAppSelector } from 'hooks/useRedux'
import { FilterPage } from 'utils/filters'

import { PrimaryRouterLink } from '.'
import RecentActivityCard from './RecentActivityCard'

const RecentActivity = () => {
  const { insights, refresh, hasLoadedInitialData, isRefreshing, error } = useDashboardInsights()

  const { activeFilterId } = useAppSelector(({ filters }) => filters)
  let search: string | undefined = undefined

  if (activeFilterId) {
    search = `?savedFilterId=${activeFilterId}`
  }
  const ErrorComponent = driftErrorStateBuilder('recent activity')

  return (
    <Flex gap={1} direction="column" css={{ position: 'relative', paddingTop: '$2' }} fullWidth>
      <Flex alignItems="center" justifyContent="space-between" fullWidth wrap='wrap'>
        <Header variant="h3">Account activity</Header>
        <PrimaryRouterLink
          to={{
            pathname: '/activity/feed',
            search
          }}>
          View all account activity
        </PrimaryRouterLink>
        {hasLoadedInitialData && !isRefreshing && insights.length > 0 && (
          <RefreshActivity
            mostRecentActivityAt={insights[0].lastActivityAt}
            filterPage={FilterPage.ACCOUNTS}
            onClick={refresh}
            showNewButton
          />
        )}
      </Flex>
      {error ?
        <Box css={{ padding: '32px 0' }}>
          <ErrorComponent />
        </Box> :
        <Flex gap={2} direction="column" fullWidth>
          {hasLoadedInitialData && insights.length ? (
            insights.map(insight => (
              <RecentActivityCard loading={!hasLoadedInitialData} {...insight} key={insight.id} />
            ))
          ) : (
            <Box
              css={{
                textAlign: 'center',
                maxWidth: '25ch',
                margin: '$2 auto 0'
              }}>
              <Text
                css={{
                  color: '$gray8'
                }}
                variant="body">
                We couldn’t find any account activity matching your search.
              </Text>
            </Box>
          )}
        </Flex>}

    </Flex>
  )
}

export default RecentActivity
